import { pdfjs } from 'react-pdf'

// `workerSrc` is one global for the whole app, so every viewer must share this module:
// a second assignment elsewhere would silently win or lose depending on bundle order.
// Served from the CDN because nginx:alpine has no mime type for .mjs and would send a
// bundled worker as octet-stream, which strict module MIME checking rejects.
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`
